/* src/app/modules/user/accountingModel/accountingModel.component.css */
/*# sourceMappingURL=accountingModel.component.css.map */
